import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { ITag } from '@fluentui/react';
import { Button, Divider, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { dividerStyles } from '../../../../app/common/styles/CommonStyleObjects';
import ReviewStatusDropdown from '../../../common/formFields/ReviewStatusDropdown';
import ProcessSearchCompanyPicker from '../../../processes/processSearch/ProcessSearchCompanyPicker';
import ProcessSearchCountryPicker from '../../../processes/processSearch/ProcessSearchCountryPicker';
import FilterWwAreaPicker from '../../list/FilterWwAreaPicker';
import { IDividendsReviewSearchState } from './IDividendsReviewSearchResults';
import IDropdownOption from '../../../../utils/types/IDropdownOption';

interface IDividendsReviewFilterProps {
  onResetFiltersClick: () => void;
  filterState: IDividendsReviewSearchState;
  onUpdateState: (newState: IDividendsReviewSearchState) => void;
}
const useStyles = makeStyles({
  filterPanel: { width: '300px' },
});

const DividendsReviewFilter = (props: IDividendsReviewFilterProps): JSX.Element => {
  const styles = dividerStyles();
  const classes = useStyles();
  const { onResetFiltersClick, filterState, onUpdateState } = props;

  const { statuses, companyCodes, countryCodes, companyAreaCodes } = filterState;

  const onFieldChange = (
    propertyName: keyof IDividendsReviewSearchState,
    value: number[] | string[],
  ) => {
    const newState = { ...filterState, [propertyName]: value };
    onUpdateState(newState);
  };

  const onStatusUpdate = (_event: React.FormEvent<HTMLElement>, items: IDropdownOption[]): void => {
    const statusesFromState = items.map((item) => item.key as string);
    onFieldChange('statuses', statusesFromState);
  };

  return (
    <StackItem grow disableShrink className={classes.filterPanel}>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <h2>Filter</h2>
        <Button onClick={onResetFiltersClick}>Reset Filters</Button>
      </Stack>
      <Divider className={styles.divider} />
      <ReviewStatusDropdown onStatusUpdate={onStatusUpdate} selectedStatuses={statuses} />
      <Divider className={styles.divider} />
      <ProcessSearchCompanyPicker
        initialSelectedCodes={companyCodes}
        onCompanyUpdate={(items: ITag[]) => {
          onFieldChange(
            'companyCodes',
            items.map((item) => item.name.split(' ')[0].toString()),
          );
        }}
      />
      <Divider className={styles.divider} />
      <ProcessSearchCountryPicker
        initialSelectedCodes={countryCodes}
        onCountryUpdate={(items: ITag[]) => {
          onFieldChange(
            'countryCodes',
            items.map((item) => item.key.toString()),
          );
        }}
      />
      <Divider className={styles.divider} />
      <FilterWwAreaPicker
        initialSelectedCodes={companyAreaCodes}
        onRegionAreaUpdate={(items: ITag[]) => {
          onFieldChange(
            'companyAreaCodes',
            items.map((item) => item.key.toString()),
          );
        }}
      />
      <Divider className={styles.divider} />
    </StackItem>
  );
};
export default DividendsReviewFilter;
